import { Fragment } from 'react';
import { Text } from '../../Text.js';
import { jsx } from 'react/jsx-runtime';
const ListItem = ({
  color,
  css,
  listWrapper
} = {}) => {
  const ListWrapper = listWrapper ? listWrapper : Fragment;
  return function listItem(node, children) {
    return (/*#__PURE__*/
      // eslint-disable-next-line @cbhq/react-no-nested-component -- TODO Fix this
      jsx(ListWrapper, {
        children: /*#__PURE__*/jsx(Text, {
          as: "li",
          css: css,
          variant: "body",
          display: "list-item",
          color: color,
          children: children
        })
      })
    );
  };
};
export { ListItem };
//# sourceMappingURL=ListItem.js.map
